import { makeStyles } from '@mui/styles';

const styles = makeStyles(() => ({
  formControl: {
    marginLeft: '0px',
    marginRight: '0px',
    marginTop: '0px',
    marginBottom: '0px',
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingTop: '0px',
    paddingBottom: '0px',
    display: 'flex',
    direction: 'column',
    justifyContent: 'stretch',
    alignContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
    backgroundColor: 'white',
    borderRadius: '10px',
  },
  visibilityIcon: {
    color: 'gray',
  },
  lineHeight: {
    lineHeight: 1,
  },
  textField: {
    width: '400px',
    height: 'auto',
    '& fieldset': {
      borderRadius: 15,
    },
  },
  underline: {
    '&&&:before': {
      borderBottom: 'none',
    },
    '&&:after': {
      borderBottom: 'none',
    },
  },
}));

export default styles;
